var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoCompany({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.667 36.6665L50.2493 37.7412C52.538 38.4278 53.6823 38.7711 54.3413 39.6568C55.0003 40.5426 55.0003 41.7373 55.0003 44.1267V56.6665",
    stroke: "#141B34",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.334 34.9998L38.334 34.9998M33.334 41.6664L38.334 41.6664",
    stroke: "#141B34",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0003 56.6666V51.6666C40.0003 50.0952 40.0003 49.3096 39.5122 48.8214C39.024 48.3333 38.2383 48.3333 36.667 48.3333H35.0003C33.429 48.3333 32.6433 48.3333 32.1551 48.8214C31.667 49.3096 31.667 50.0952 31.667 51.6666V56.6666",
    stroke: "#141B34",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.334 56.6665L56.6673 56.6665",
    stroke: "#141B34",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.001 56.6666V31.1953C25.001 27.0107 25.001 24.9184 26.3196 23.8803C27.6383 22.8422 29.58 23.4058 33.4635 24.5331L41.7968 26.9519C44.1404 27.6322 45.3121 27.9723 45.9899 28.8993C46.6676 29.8264 46.6676 31.089 46.6676 33.6142V56.6666",
    stroke: "#141B34",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoCompany);
export default __webpack_public_path__ + "static/media/no-company.d9e508f88734c89607e4985860235a45.svg";
export { ForwardRef as ReactComponent };